// tog‘a #2065 W1 (2026-09-15, S2: bitta — avtomatik, ko‘p — tanlash): skan bir nechta tovarga yoki partiyaga mos kelganda tanlash oynasi.
// Qadamlar: tovar (artikul, shtrix-kod, moslik turi, qoldiq) → kerak bo‘lsa partiya (ombor va soni). Barmoq bilan bosishga mos katta qatorlar.
import React, { useEffect, useState } from "react"
import { Button, Empty, Modal, Radio, Space, Tag } from "antd"
import { useTranslation } from "react-i18next"
import type { ScanItem } from "./scanTypes"
import { useIsMainSystem } from "../../utils/mainSystem"   // tog'a #4100

export interface ScanPickModalProps {
  open: boolean
  code: string
  items: ScanItem[]
  needBatch: boolean
  onPick: (item: ScanItem, batchNumber?: string) => void
  onCancel: () => void
}

const num = (v: any) => {
  const n = Number(v || 0)
  return n < 0 ? 0 : Math.round(n * 100) / 100
}

export default function ScanPickModal({ open, code, items, needBatch, onPick, onCancel }: ScanPickModalProps) {
  const { t } = useTranslation()
  const bm = useIsMainSystem()   // tog'a #4100: ro'yxatda tovar partiyasi faqat glavniy tizimda
  const single = items.length === 1 ? items[0] : null
  const [item, setItem] = useState<ScanItem | null>(single)
  const [batch, setBatch] = useState<string | undefined>(undefined)

  useEffect(() => {
    setItem(items.length === 1 ? items[0] : null)
    setBatch(undefined)
  }, [items, open])

  const choose = (it: ScanItem) => {
    const batches = it.batches || []
    if (needBatch && !it.exactBatch && batches.length > 1) {
      setItem(it)
      setBatch(undefined)
      return
    }
    onPick(it, it.exactBatch || (batches.length === 1 ? batches[0].batchNumber : undefined))
  }

  const batchStep = !!item && needBatch && !item.exactBatch && (item.batches || []).length > 1
  const matchLabel = (m: string) => t("scanMatch_" + m, m)

  return (
    <Modal
      visible={open}
      zIndex={1070}
      onCancel={onCancel}
      destroyOnClose
      title={batchStep ? t("scanPickBatchTitle", "Выберите партию") : t("scanPickTitle", { code, defaultValue: "Код {{code}}: выберите товар" })}
      footer={
        batchStep
          ? [
              items.length > 1 ? (
                <Button key="back" onClick={() => setItem(null)}>
                  {t("back", "Назад")}
                </Button>
              ) : null,
              <Button key="ok" type="primary" disabled={!batch} onClick={() => item && onPick(item, batch)}>
                {t("add", "Добавить")}
              </Button>,
            ]
          : null
      }
    >
      <div data-scan-owner="pick">
        {!batchStep && (
          items.length ? (
            <Space direction="vertical" style={{ width: "100%" }} size={8}>
              {items.map((it) => (
                <Button
                  key={it.product.id}
                  block
                  size="large"
                  style={{ height: "auto", textAlign: "left", whiteSpace: "normal", padding: "8px 12px" }}
                  onClick={() => choose(it)}
                >
                  <div style={{ fontWeight: 600 }}>{it.product.name}</div>
                  <div style={{ fontSize: 12, opacity: 0.8, marginTop: 2 }}>
                    {it.product.article ? <Tag>{it.product.article}</Tag> : null}
                    {it.product.barCode ? <Tag color="blue">{it.product.barCode}</Tag> : null}
                    {/* tog'a #4100: tovar partiyasi (yoki yagona qoldiqli partiya) — faqat glavniy tizimda */}
                    {(() => { const pb = bm ? it.product.batchNumber || (it.batches?.length === 1 ? it.batches[0].batchNumber : "") : ""; return pb ? <Tag color="gold">{t("batchLbl", "Партия")}: {pb}</Tag> : null })()}
                    <Tag color="purple">{matchLabel(it.matchType)}</Tag>
                    {t("totalCount", "Остаток")}: <b>{num(it.total)}</b>
                  </div>
                </Button>
              ))}
            </Space>
          ) : (
            <Empty />
          )
        )}
        {batchStep && item && (
          <>
            <div style={{ marginBottom: 8, fontWeight: 600 }}>
              {item.product.name} {item.product.article ? <Tag>{item.product.article}</Tag> : null}
            </div>
            <Radio.Group value={batch} onChange={(e) => setBatch(e.target.value)} style={{ width: "100%" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                {item.batches.slice(0, 50).map((b) => (
                  <Radio key={b.purchaseId + ":" + b.batchNumber} value={b.batchNumber} style={{ padding: "6px 0" }}>
                    <b>{b.batchNumber}</b> · {num(b.amount)}
                    {b.warehouseName ? " · " + b.warehouseName : ""}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </>
        )}
      </div>
    </Modal>
  )
}
